import { ORDER_ACTIONS } from '../types/actionTypes';

const initialState = {
  orders: [],
  pagination: {
    total: 0,
    page: 1,
    limit: 10,
    totalPages: 0
  },
  currentOrder: null,
  isLoading: false,
  error: null
};

export const orderReducer = (state = initialState, action) => {
  switch (action.type) {
    case ORDER_ACTIONS.FETCH_ORDERS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    
    case ORDER_ACTIONS.FETCH_ORDERS_SUCCESS:
      return {
        ...state,
        orders: action.payload.orders,
        pagination: action.payload.pagination,
        isLoading: false,
        error: null
      };
    
    case ORDER_ACTIONS.FETCH_ORDERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    
    case ORDER_ACTIONS.FETCH_ORDER_REQUEST:
    case ORDER_ACTIONS.UPDATE_ORDER_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    
    case ORDER_ACTIONS.FETCH_ORDER_SUCCESS:
      return {
        ...state,
        currentOrder: action.payload,
        isLoading: false,
        error: null
      };
    
    case ORDER_ACTIONS.UPDATE_ORDER_SUCCESS:
      return {
        ...state,
        currentOrder: action.payload,
        isLoading: false,
        error: null
      };
    
    case ORDER_ACTIONS.FETCH_ORDER_FAILURE:
    case ORDER_ACTIONS.UPDATE_ORDER_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    
    default:
      return state;
  }
}; 